var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloudBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16659 22.5401C3.30736 21.2956 2.08325 19.1762 2.08325 16.7708C2.08325 13.1578 4.84516 10.1899 8.37285 9.86319C9.09447 5.4737 12.9061 2.125 17.4999 2.125C22.0937 2.125 25.9054 5.4737 26.627 9.86319C30.1547 10.1899 32.9166 13.1578 32.9166 16.7708C32.9166 19.1762 31.6925 21.2956 29.8333 22.5401M11.3333 22.1667L17.4999 16M17.4999 16L23.6666 22.1667M17.4999 16V29.875",
    stroke: "black",
    strokeWidth: 3.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloudBlack);
export default __webpack_public_path__ + "static/media/upload-cloud-black.98f48f7bbeaec82c1e1133144777ef5d.svg";
export { ForwardRef as ReactComponent };